import React from 'react';
import { useNavigate } from 'react-router-dom';
import { booksData } from '../data/booksData';
import { eBooksData } from '../data/eBooksData';

function Home() {
  const navigate = useNavigate();

  return (
    <div className="covers-box">
      <h3 className="heading-3 text-transformed u-margin-bottom-xl">
        Books Top 5 Sellers
      </h3>

      <div className="covers-box__top u-margin-bottom-xl">
        <div className="covers-box__cell">
          <img
            src={booksData[12].image}
            alt="book cover"
            className="book-cover__active"
            onClick={() => {
              navigate('/books');
            }}
          />
        </div>

        <div className="covers-box__cell">
          <img
            src={booksData[1].image}
            alt="book cover"
            className="book-cover__active"
            onClick={() => {
              navigate('/books');
            }}
          />
        </div>

        <div className="covers-box__cell">
          <img
            src={booksData[8].image}
            alt="book cover"
            className="book-cover__active"
            onClick={() => {
              navigate('/books');
            }}
          />
        </div>

        <div className="covers-box__cell">
          <img
            src={booksData[13].image}
            alt="book cover"
            className="book-cover__active"
            onClick={() => {
              navigate('/books');
            }}
          />
        </div>

        <div className="covers-box__cell">
          <img
            src={booksData[4].image}
            alt="book cover"
            className="book-cover__active"
            onClick={() => {
              navigate('/books');
            }}
          />
        </div>
      </div>

      <h3 className="heading-3 text-transformed u-margin-bottom-xl">
        E-Books Top 5 Sellers
      </h3>

      <div className="covers-box__bottom">
        <div className="covers-box__cell">
          <img
            src={eBooksData[12].image}
            alt="book cover"
            className="book-cover__active"
            onClick={() => {
              navigate('/e-books');
            }}
          />
        </div>

        <div className="covers-box__cell">
          <img
            src={eBooksData[1].image}
            alt="book cover"
            className="book-cover__active"
            onClick={() => {
              navigate('/e-books');
            }}
          />
        </div>

        <div className="covers-box__cell">
          <img
            src={eBooksData[8].image}
            alt="book cover"
            className="book-cover__active"
            onClick={() => {
              navigate('/e-books');
            }}
          />
        </div>

        <div className="covers-box__cell">
          <img
            src={eBooksData[13].image}
            alt="book cover"
            className="book-cover__active"
            onClick={() => {
              navigate('/e-books');
            }}
          />
        </div>

        <div className="covers-box__cell">
          <img
            src={eBooksData[4].image}
            alt="book cover"
            className="book-cover__active"
            onClick={() => {
              navigate('/e-books');
            }}
          />
        </div>
      </div>
    </div>
  );
}

export default Home;
